module.exports = __webpack_public_path__ + "img/chest5_open.7bcad792.png";